import Vue from "vue";
import EditorDatePickerHost from "./EditorDatePickerHost.vue";
import { dismissSlashMenuUI } from "@components/TiptapEditor/slashCommandItems";

function getTodayIsoDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function destroyHost(vm, mountEl) {
  if (vm) {
    vm.$destroy();
  }
  if (mountEl?.parentNode) {
    mountEl.parentNode.removeChild(mountEl);
  }
}

const EditorDatePickerHostConstructor = Vue.extend(EditorDatePickerHost);

/**
 * Mounts the shared DatePicker calendar for checkpoint / Notion editor slash → Date.
 * Used by components/webcomponents-dist/notion-editor-date-patch.js until the
 * webcomponents bundle ships the same DatePicker flow natively.
 */
export function mountEditorDatePicker(onSave) {
  if (typeof onSave !== "function") {
    return;
  }

  dismissSlashMenuUI();

  if (typeof window !== "undefined" && window.__exiqActiveEditorDatePicker) {
    window.__exiqActiveEditorDatePicker.close();
  }

  const mountEl = document.createElement("div");
  mountEl.className = "exiq-editor-date-picker-host";
  document.body.appendChild(mountEl);

  let vm = null;
  let onEscapeKey = null;

  const close = () => {
    if (onEscapeKey) {
      document.removeEventListener("keydown", onEscapeKey, true);
      onEscapeKey = null;
    }
    if (typeof window !== "undefined" && window.__exiqActiveEditorDatePicker?.vm === vm) {
      window.__exiqActiveEditorDatePicker = null;
    }
    destroyHost(vm, mountEl);
    vm = null;
  };

  onEscapeKey = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      close();
    }
  };
  document.addEventListener("keydown", onEscapeKey, true);

  vm = new EditorDatePickerHostConstructor({
    propsData: {
      initialValue: getTodayIsoDate(),
      onDone: close,
    },
  });

  vm.$on("save", (isoDate) => {
    onSave(isoDate);
  });
  vm.$mount(mountEl);

  if (typeof window !== "undefined") {
    window.__exiqActiveEditorDatePicker = { vm, close };
  }
}

export function registerEditorDatePickerHost() {
  if (typeof window === "undefined") {
    return;
  }
  window.__exiqMountEditorDatePicker = mountEditorDatePicker;
}
